
import SearchItemArea from '../../common/search/SearchItemArea';
import fetchWrapper from '../../helpers/fetchWrapper';
import { swalError } from '../../../app/helpers/swal';
import { ArrowLeftOutlined } from '@ant-design/icons';
import { Button, Form, Input } from 'antd';
import { useHistory } from "react-router-dom";
import { useEffect, useRef, useState } from 'react';
import React from 'react';
export const WidgetsSettings = (props) => {
	const { filterData, slug, setOpen, setActiveFilter, setActionCard, data, moduleInfo } = props;
	const [widgetSettingData, setWidgetSettingData] = useState({ title: '', search_column: '', search_option: '' });
	const [submitFlag, setSubmitFlag] = useState(false);
	const [mainWidgetTitle, setMainWidgetTitle] = useState();
	const [form] = Form.useForm();
	const history = useHistory();
	const ref = useRef();
	const filterTabData = (key) => {
		setMainWidgetTitle([]);
		const newWidgetsData = [...data].filter((item) => item.dashboard_widget_id === parseInt(key));
		setMainWidgetTitle(filterData.title ? filterData.title : newWidgetsData[0].main_title);
	};
	const searchFilter = async (e) => {
		console.log('eeeee', e, submitFlag);
		// setWidgetSettingData((prev) => ({ ...prev, search_column: e }));
		if (submitFlag) {
			const dndLayout = props.data.map((item) => {
				return JSON.parse(item.dnd_layout_config);
			});
			const maxPosition = dndLayout.map((item) => {
				return Math.max(...item.map((o) => o.y));
			});
			const finalMax = Math.max(...maxPosition) + 1;
			const timestamp = new Date().getTime();
			const WidHeight = JSON.parse(filterData.dnd_layout_config);
			console.log('widHeight',WidHeight);
			const payload = {
				//module_id: moduleInfo.module_id,
				module_id: 22,
				dashboard_widget_id: filterData.dashboard_widget_id,
				dnd_layout_config: JSON.stringify([{ x: 0, y: finalMax, w: WidHeight[0]?.w || 4, h: WidHeight[0]?.h || 5, i: String(timestamp) }]),
				search_option:
					widgetSettingData.search_option !== '' ? JSON.stringify(widgetSettingData.search_option) : '',
				title: widgetSettingData.title !== '' ? widgetSettingData.title : filterData?.title,
			};
			console.log('payload',payload);
			payload.search_column = e?.length > 0 || e !== 'undefined' ? JSON.stringify(e) : [];
			await fetchWrapper
				.post('/dashboard/widget/userwise-widget', payload)
				.then((response) => {
					if (!response?.error) {
						setOpen(false);
						history.push({
							pathname: `/`,
						});
					} else {
						swalError(response?.error?.message);
					}
				})
				.catch((error) => {
					console.log(error?.message);
				});
		}
	};

	const onChange = (e) => {
		setWidgetSettingData((prev) => ({ ...prev, title: e.target.value }));
	};
	const handleSubmit = async () => {
		setSubmitFlag(true);
		if (ref.current.filter()) {
			ref.current.filter();
		} else {
			searchFilter();
		}
	};

	const getActiveFieldIds = (e) => {
		setWidgetSettingData((prev) => ({ ...prev, search_option: e }));
	};
	useEffect(() => {
		filterData && filterTabData(filterData.dashboard_widget_id);
	}, [filterData]);

	useEffect(() => {
		form.setFieldValue('title', mainWidgetTitle === filterData?.title ? filterData?.title : mainWidgetTitle);
	}, [mainWidgetTitle, filterData?.title]);
	useEffect(() => {
		setSubmitFlag(true);
	}, [form.submit()]);
	return (
		<div className="flex" style={{minHeight:'200px'}}>
			<Form form={form} layout="vertical">
				<Form.Item label="Name" name="title">
					<Input placeholder="Enter Title" onChange={onChange} style={{ width: '250px' }} />
				</Form.Item>

				<SearchItemArea
					slug={slug}
					handleSearch={searchFilter}
					getActiveFieldIds={getActiveFieldIds}
					searchRef={ref}
					showFilterBtn={false}
				/>

				<Form.Item className="text-end mt-3" style={{float:'right'}}>
					<Button
						type="primary"
						className="mr-2"
						icon={<ArrowLeftOutlined />}
						onClick={() => {
							setActionCard(false);
							setActiveFilter(false);
						}}
					>
						Back
					</Button>
					<Button
						type="primary"
						onClick={() => {
							handleSubmit();
							// ref.current.filter();
						}}
					>
						Add Widget
					</Button>
				</Form.Item>
			</Form>
		</div>
	);
};
